import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';

declare var IS_RUNNING_IN_APP_POOL;

export class IndividualUserFunctionClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(clientId: number, functionName: string): Promise<boolean, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/User/IndividualUserFunction/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { clientId: clientId, functionName: functionName }

    return AjaxWrapper.get<boolean, any>(url, data);
  }
}

